export const IconNameConvert = (name: string) => {
  let iconName = name.toLowerCase();
  if (name.toLowerCase().includes("apple")) {
    iconName = "appleMusic";
  }
  if (name.toLowerCase().includes("heart")) {
    iconName = "iHeartRadio";
  }
  if (name.toLowerCase().includes("amazon")) {
    iconName = "amazonMusic";
  }
  if (name.toLowerCase().includes("youtube")) {
    iconName = "youtubeMusic";
  }
  if (name.toLowerCase().includes("deezer")) {
    iconName = "deezer";
  }

  return iconName;
};
